import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export interface GetUsersResult {
  success: boolean;
  data?: ZitadelUser[];
  error?: string;
}

export const getUsersUseCase = async (
  signal: AbortSignal,
): Promise<GetUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getUsers(namespace, signal);

    return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch users. Please try again later.",
      ).message,
    };
  }
};
